import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DateInput } from "@/components/DateInput";
import { Warehouse } from "lucide-react";

export function AddressSection({ form, setForm, isEditable }) {
  const s = (field, val) => setForm({ ...form, [field]: val });
  const deliveryType = form.delivery_type || "consegna";

  return (
    <div className="card-surface p-5 space-y-4">
      <h2 className="text-sm font-semibold font-['Outfit'] text-zinc-500 uppercase tracking-wider">Indirizzi</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <AddressBlock prefix="pickup" label="Carico (Ritiro)" form={form} setField={s} disabled={!isEditable} />
        <div className="space-y-3">
          {/* Delivery type selector */}
          {isEditable && (
            <div className="flex items-center gap-1 bg-zinc-100 rounded-sm p-0.5 w-fit">
              <button type="button" onClick={() => s("delivery_type", "consegna")} data-testid="delivery-type-consegna"
                className={`px-3 py-1.5 text-xs font-medium rounded-sm transition-colors ${deliveryType === "consegna" ? "bg-white text-[#002FA7] shadow-sm" : "text-zinc-500 hover:text-zinc-700"}`}>
                Scarico (Consegna)
              </button>
              <button type="button" onClick={() => s("delivery_type", "deposito")} data-testid="delivery-type-deposito"
                className={`px-3 py-1.5 text-xs font-medium rounded-sm transition-colors ${deliveryType === "deposito" ? "bg-white text-[#002FA7] shadow-sm" : "text-zinc-500 hover:text-zinc-700"}`}>
                Scarico (Deposito)
              </button>
            </div>
          )}
          {!isEditable && (
            <p className="text-xs font-semibold text-zinc-700">
              Scarico (Consegna){deliveryType === "deposito" ? ": in deposito" : ""}
            </p>
          )}

          {deliveryType === "deposito" ? (
            <div className="space-y-3">
              <div className="flex items-center gap-3 p-4 bg-amber-50 border border-amber-200 rounded-sm">
                <Warehouse className="w-5 h-5 text-amber-600 shrink-0" />
                <p className="text-sm text-amber-700">Deposito in magazzino aziendale. Non è necessario compilare l'indirizzo di scarico.</p>
              </div>
              <div className="space-y-1">
                <Label className="text-xs text-zinc-500">Data Scarico *</Label>
                <DateInput data-testid="delivery-date" value={form.delivery_date} onChange={(e) => s("delivery_date", e.target.value)} disabled={!isEditable} className="rounded-sm" />
              </div>
            </div>
          ) : (
            <AddressBlock prefix="delivery" label={null} form={form} setField={s} disabled={!isEditable} />
          )}
        </div>
      </div>
    </div>
  );
}

function AddressBlock({ prefix, label, form, setField, disabled }) {
  return (
    <div className="space-y-3">
      {label && <p className="text-xs font-semibold text-zinc-700">{label}</p>}
      <Input data-testid={`${prefix}-address`} placeholder="Indirizzo *" value={form[`${prefix}_address`]} onChange={(e) => setField(`${prefix}_address`, e.target.value)} disabled={disabled} className="rounded-sm" required />
      <div className="grid grid-cols-3 gap-2">
        <Input placeholder="Città *" value={form[`${prefix}_city`]} onChange={(e) => setField(`${prefix}_city`, e.target.value)} disabled={disabled} className="rounded-sm" required />
        <Input placeholder="Prov. *" value={form[`${prefix}_province`]} onChange={(e) => setField(`${prefix}_province`, e.target.value.toUpperCase().slice(0, 2))} disabled={disabled} className="rounded-sm" maxLength={2} required />
        <Input placeholder="CAP *" value={form[`${prefix}_cap`]} onChange={(e) => setField(`${prefix}_cap`, e.target.value)} disabled={disabled} className="rounded-sm" maxLength={5} required />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Input data-testid={`${prefix}-floor`} placeholder="Piano" value={form[`${prefix}_floor`]} onChange={(e) => setField(`${prefix}_floor`, e.target.value)} disabled={disabled} className="rounded-sm" />
        <Input data-testid={`${prefix}-apartment`} placeholder="Int. N°" value={form[`${prefix}_apartment`]} onChange={(e) => setField(`${prefix}_apartment`, e.target.value)} disabled={disabled} className="rounded-sm" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs text-zinc-500">Tipo Accesso</Label>
        <Select value={form[`${prefix}_access_type`]} onValueChange={(v) => setField(`${prefix}_access_type`, v)} disabled={disabled}>
          <SelectTrigger className="rounded-sm" data-testid={`${prefix}-access-type`}><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="normale">Normale Accesso</SelectItem>
            <SelectItem value="elevatore">Richiesta Elevatore</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <Label className="text-xs text-zinc-500">Data *</Label>
        <DateInput data-testid={`${prefix}-date`} value={form[`${prefix}_date`]} onChange={(e) => setField(`${prefix}_date`, e.target.value)} disabled={disabled} className="rounded-sm" />
      </div>
    </div>
  );
}
